import { createFileRoute, redirect } from '@tanstack/react-router';

// The old Prospects page. The Prospects book on the Fundraising page replaced it, so a bookmark lands
// there. One person's page lives under it, at /admin/fundraising/prospects/$prospectId.
export const Route = createFileRoute('/admin/fundraising/prospects/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/fundraising', replace: true });
  },
});
